import styled from 'styled-components'

export default styled.div`
    color: #333;
    background-color: lightgrey;
    border-color: #ddd;
    padding: 4px 4px;
    border-top-left-radius: 3px;
    border-top-right-radius: 3px;
    margin-bottom: 5px;
    margin-top: 5px;
`;



// WEBPACK FOOTER //
// ./src/components/GroupTitle.js